var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.999,
    height: 22.999
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6326",
    d: "M16.147 0h-9.3A6.859 6.859 0 000 6.851v9.3A6.859 6.859 0 006.851 23h9.3A6.859 6.859 0 0023 16.147v-9.3A6.859 6.859 0 0016.147 0zm4.538 16.147a4.538 4.538 0 01-4.538 4.538h-9.3a4.538 4.538 0 01-4.538-4.538v-9.3a4.538 4.538 0 014.542-4.533h9.3a4.538 4.538 0 014.538 4.538v9.3z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6327",
    d: "M11.499 5.551a5.948 5.948 0 105.948 5.948 5.955 5.955 0 00-5.948-5.948zm0 9.583a3.635 3.635 0 113.635-3.635 3.635 3.635 0 01-3.635 3.635z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 1",
    cx: 1.425,
    cy: 1.425,
    r: 1.425,
    transform: "translate(16.034 4.17)",
    fill: "currentColor"
  })));
}
export default SvgInstagramOutline;